import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { ButtonModule } from '@wuitk/angular/components/button';
import { LoginModule } from '@wuitk/angular/components/login-screen';
import { GestureConfig } from '@wuitk/angular/core';
import 'hammerjs';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LabelModule } from '@wuitk/angular/components/label';
import { CommonModule } from '@wuitk/angular/components/common';
import { PasswordModule } from '@wuitk/angular/components/password-box';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TextModule } from '@wuitk/angular/components/text';
import { ComponentsModule } from './components/components.module';
import { ComponentsRoutingModule } from './components/components-routing.module';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
import { DashboardModule } from './dashboard/dashboard.module';
import { DashboardRoutingModule } from './dashboard/dashboard-routing.module';
import { AuthComponent } from './login/auth/auth.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatListModule} from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MultiselectModule } from '@wuitk/angular/components/multiselect';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieService } from 'ngx-cookie-service';
import { AppProfile } from './shared/app-profile/app-profile';
import { AppProfileService } from './core/services/app-profile.service';
import { TabsModule } from '@wuitk/angular/components/tabs';
import { SharedModule } from './shared/shared.module';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

ModuleRegistry.registerModules([AllCommunityModule]);

@NgModule({
    declarations: [AppComponent, LoginComponent, AuthComponent],
    imports: [
      MatProgressSpinnerModule,
        AppRoutingModule,
        HammerModule,
        BrowserModule,
        LoginModule,
        LabelModule,
        TextModule,
        CommonModule,
        ButtonModule,
        PasswordModule,
        BrowserAnimationsModule,
        FormsModule,
        ComponentsModule,
        DashboardModule,
        ComponentsRoutingModule,
        DashboardRoutingModule,
        AgGridModule,
        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
        MatSidenavModule,
        MatListModule,
        MatMenuModule,
        MultiselectModule,
        TabsModule,
        SharedModule,
        TranslateModule.forRoot({
          loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
          }
      })
    ],
    exports: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        CookieService,
        AppProfile,
        AppProfileService,
        {
            provide: APP_INITIALIZER,
            useFactory: AppProfileProviderFactory,
            deps: [AppProfile, AppProfileService],
            multi: true
        },
        { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        // provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync()
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

/**
 * Factory for load AppProfile data when an application is initialized.
 * @param provider -- instance for load AppProfile
 * @param service -- instance of load AppProfile service
 */
export function AppProfileProviderFactory(provider: AppProfile, service: AppProfileService) {
  return () => provider.load(service);
}
